<template>
  <div class="project-second-module-update-order">
    <el-card shadow="never">
      <div slot="header" class="clearfix">{{projectName}}/排序</div>
      <div class="order-wrap">
        <el-row v-for="(item, index) in list" :key="index">
          <el-col :span="12">
            <span>{{ item.resourceName }}</span>
          </el-col>
          <el-col :span="12"><el-input v-model="item.showOrder"></el-input></el-col>
        </el-row>
      </div>
    </el-card>
    <div class="btn-footer">
      <el-button type="primary" @click="updateConfigResourcesShowOrder">更新</el-button>
    </div>
  </div>
</template>

<script>
import PROJECTAPI from '@/api/project';
import COMMONAPI from '@/api/common';
export default {
  props: {
    projectName: {
      type: [String, Number]
    },
    projectId: {
      type: [String, Number]
    }
  },
  data() {
    return {
      list: []
    };
  },
  created() {
    this.searchConfigProjectStatisticsListForOrder();
  },
  methods: {
    //查询模块列表
    searchConfigProjectStatisticsListForOrder() {
      let params = { entityId: this.projectId };
      PROJECTAPI.searchConfigProjectStatisticsListForOrder(params).then(res => {
        if (res.data.code == 200) {
          this.list = res.data.data;
        }
      });
    },
    //添加资源配置(组织资源配置、项目资源配置)
    updateConfigResourcesShowOrder() {
      let params = { configResourceVOS: this.list };
      COMMONAPI.updateConfigResourcesShowOrder(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success('操作成功');
          this.searchConfigProjectStatisticsListForOrder();
        }else{
          this.$message.success('操作失败');
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.project-second-module-update-order {
  width: 70%;
  margin: 20px auto;

  .order-wrap {
    max-height: 50vh;
    overflow: auto;
    .el-row {
      margin-bottom: 10px;
      .el-col:nth-child(1) {
        text-align: right;
        height: 32px;
        line-height: 32px;
        span {
          display: inline-block;
          width: auto;
          margin-right: 10px;
        }
      }
      .el-col:nth-child(2) {
        .el-input {
          width: 200px;
          margin-left: 10px;
        }
      }
    }
  }
.btn-footer{
  margin:20px;
  text-align: center;
}
  .btn {
    width: 120px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/boss/project/projectsecondmoduleupdateorder.vue